<template>
    <div>
        <Wp_image v-if="skuInfo.imageInfo && skuInfo.imageInfo.imageList" :url="skuInfo.imageInfo.imageList[0].url" :img-gray="imgGray"></Wp_image>
        <div class="sku_title">
            {{skuInfo.skuName}}
        </div>
        <div class="sku_tags">

            <div style="float:left;" v-if="couponData && couponData.discount && skuInfo.priceInfo.lowestCouponPrice">
<!--                <JdCouponBar :couponData="couponData" ></JdCouponBar>-->
                <van-tag color="red" plain round style="padding: 1px 6px">券 ¥ {{couponData.discount}}</van-tag>
            </div>

            <div v-else style="float:left;" >
                <span v-if="skuInfo.pinGouInfo && skuInfo.pinGouInfo.pingouPrice" style="color:red;margin: 2px 5px 2px 0px;">
                        <Icon type="ios-contacts" size="16" style="margin-top: -2px"/>
                        {{skuInfo.pinGouInfo.pingouTmCount}}人拼
                </span>
                <span v-else-if="skuInfo.isHot===1">
                    <van-tag color="red" plain style="padding: 1px 6px">爆品</van-tag>
                </span>

                <span v-else>
                    <van-tag color="rgba(0,0,0,0)" style="padding: 1px 6px;">&nbsp;</van-tag>
                </span>

            </div>
        </div>

        <div>
            <div v-if="skuInfo.priceInfo" style="color:red; font-size: 13px;">
                <span v-if="couponData && couponData.discount && skuInfo.priceInfo.lowestCouponPrice">
                    <span>
                        ¥<span>{{Number((skuInfo.priceInfo.lowestCouponPrice).toFixed(2))}}</span>
                    </span>
                    <span>&nbsp;</span>
                    <span style="font-size:10px;color:gray;text-decoration:line-through;">
                        ¥{{Number(skuInfo.priceInfo.lowestPrice.toFixed(2))}}
                    </span>
                </span>
                <span v-else>
                    ¥<span>{{Number(skuInfo.priceInfo.lowestPrice.toFixed(2))}}</span>
                </span>
            </div>
        </div>

    </div>
</template>

<script>
    import Wp_image from "./Wp_image";
    export default {
        name: "JdSkuInfoSimpleCard",
        components: {Wp_image},
        props: {
            skuInfo: {type: Object, default: null},
            imgGray:{type: Boolean, default: false}
        },

        data(){
            return{
                couponData: {},
            }
        },

        created(){
            if(this.skuInfo){
                this.findCoupon();
            }
        },

        methods:{
            /**
             * 查找优惠券
             */
            findCoupon() {
                if(this.skuInfo.couponInfo && this.skuInfo.couponInfo.couponList){
                    let couponList = this.skuInfo.couponInfo.couponList;
                    let _couponData = this.$common.autoFindCoupon2(couponList);
                    if (_couponData) {
                        this.couponData = _couponData;
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .sku_title {
        /*height: 45px;*/
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        /*word-wrap: break-word;*/
        /*英文自动换行*/
        word-break: break-word;
    }

    .sku_tags {
        display: inline-block;
        margin-top: 5px;
    }
</style>